import { CommonModule, NgFor, NgIf, DOCUMENT } from '@angular/common';
import {
  Component,
  Input,
  HostListener,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { AuthenticationService } from '../../_services/authentication.service';
import { DatasearchService } from '../../_services/datasearch.service';
import { GlobalService } from '../../_services/global.service';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js'; // @ts-ignore
import { RecaptchaModule, ReCaptchaV2Component } from 'ng-recaptcha';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import md5 from 'md5';
import { BusyService } from '../../_services/busy.service';
declare var bootstrap: any;
declare var $: any;
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    DropdownModule,
    NgIf,
    CommonModule,
    RouterLink,
    NgFor,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    ToastModule,
    TooltipModule,
  ],
  providers: [MessageService],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @ViewChild('alertModal', { static: false }) alertModal!: ElementRef;
  @ViewChild('recaptchaRef') recaptchaRef!: ReCaptchaV2Component;
  @ViewChild('userSettingDialog') userSettingDialog!: ElementRef;
  @Input() transparent: boolean = false;
  @Input() homePage: boolean = false;
  lists: any = [];
  labels: { id: number; profession: string; checked: boolean }[] = [];
  ids: number[] = [];
  headerData: any = {};
  signUpForm: FormGroup = this.fb.group({});
  signInForm: FormGroup = this.fb.group({});
  demorequestForm: FormGroup = this.fb.group({});
  forgotPasswordForm: FormGroup = this.fb.group({});
  selectedCountsignup: number = 0;
  selectedCountdemo: number = 0;
  languages: any[] = []; // Define languages array
  selectedLanguage: any = {};
  errorMessage1: string = '';
  errorMessage: string = '';
  accessKey: string = '';

  isLoggingIn: boolean = false;
  isSigningUp: boolean = false;
  successMessage: string = '';
  errorMessageforgot: string = '';
  showSecondForm: boolean = false;
  showProducts = false;
  descDropdown = false;
  servicesDropdown = false;
  overAgroProducts = false;
  overProductsDropdown = false;
  overHeaderDesc = false;
  overDescDropdown = false;
  overHeaderservices = false;
  overServicesDropdown = false;
  showMenu = false;
  selectedMenu = '';
  details = ['Profession', 'Professional Detail', 'Personal Detail'];
  showThirdForm: boolean = false;
  showWarn: boolean = false;
  alertVisible: boolean = false;
  isSignedIn = false;
  countries: any[] = [];
  originalCountries: any[] = [];
  isSubmitted: boolean = false;
  userData: any = {};
  recaptchaResponse: string | null = null;
  formSubmitted = false;
  copyMessage: string | undefined;
  recaptchaSiteKey = '6LfvdWgqAAAAAB4irdmbPCmlpmyBzGLjGVIrHE_S'; // live
  // recaptchaSiteKey = '6Lcpo3QqAAAAAIKDJyb4lg4QKCWMuQMA7VxbP9uD'; // local
  logoUrl = 'https://www.chemrobotics.com/agropat/uploads/thumbnail/';
  verticals: { vertical: string; checked: boolean }[] = [
    { vertical: 'AgroPat Ultimate Discovery Suite', checked: false },
    { vertical: 'AgroPat Ultimate Discovery Suite - Classic', checked: false },
    { vertical: 'AgroPat Ultimate Generic Suite', checked: false },
    { vertical: 'Technical Routes - Essential Chemical Manufacturing Guide', checked: false },
    { vertical: 'ChemiTracker - A Supplier Guide', checked: false },
    { vertical: 'Global MRL Database', checked: false },
    { vertical: 'QuikPatent - Agrochemical Constraining Patent Guide', checked: false },
    { vertical: 'Indian Pesticide Database (IPD)', checked: false },
    { vertical: 'Global Agro Product Directory (GAPD)', checked: false },
    { vertical: 'PharmVetPat Ultimate', checked: false },
    { vertical: 'PharmVetPat Ultimate - API Generic Suite', checked: false },
    { vertical: 'SPC Database - Europe Generic Constraining Date Guide', checked: false },
    { vertical: 'Indian Medicine Database (IMD)', checked: false },
    { vertical: 'AgroPharm XIM 1.0 DB', checked: false },
    { vertical: 'AgroPharm XIM 2.0 DB', checked: false },
    { vertical: 'ActivePatents - Pharmaceutical API Constraining Patent Guide', checked: false },
    { vertical: 'BuyChem - Chemical Buy-Sale Platform', checked: false },
    { vertical: 'ChemRobotics® Jobs', checked: false },
    { vertical: 'Global Business Events - Trade Shows, Exhibitions, & Conferences Beta', checked: false },
    { vertical: 'Knō Ure KompeteR - Global Innovation Watch', checked: false },
    { vertical: 'Company Directory', checked: false }
  ];
  sentEmail: string = '';
  isLoggedIn: boolean = false;
  dropdownOpen = false;
  userSetting = false;
  selectedBrochure: any;
  brochures: any[] = [];
  private openModalCount: number = 0;

  password: any = 'password';
  show = false;

  constructor(
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private datasearch: DatasearchService,
    private globalService: GlobalService,
    private router: Router,
    private busyService: BusyService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.getHeaderData();
    this.loadCountryCodes();
    this.initialiseForm();
    this.checkUser();
    this.authenticationService.getLoginUser().subscribe((val) => {
      this.isSignedIn = val;
    });
    this.authenticationService.getCurrentUserSubject().subscribe((val) => {
      this.userData = val;
    });
    this.globalService.getOpenDemoModel().subscribe((open: boolean) => {
      if (open) {
        $('#demo-form').modal('show'); // Assuming jQuery is being used for modal
      }
    });
    this.globalService.getOpenSignInModal().subscribe((open: boolean) => {
      if (open) {
        $('#sign-in').modal('show'); // Assuming jQuery is being used for modal
      }
    });
    setTimeout(() => {
      this.onWindowScroll();
    }, 0);

    // this.updateCount();
    this.updateSelectedCount();
    this.getList();
    this.getLabels();
    this.getBrochureData();
    this.setupModalCloseListeners();
  }
  // Set up modal close listeners
  private setupModalCloseListeners() {
    const modals = ['sign-in', 'sign-up', 'demo-form', 'alertModel']; // Add your modal IDs here
    modals.forEach((modalId) => {
      const modalElement = document.getElementById(modalId);
      if (modalElement) {
        // Use jQuery to attach the event listener
        $(modalElement).on('hidden.bs.modal', () => {
          // Reload the window when the modal is closed
        });
      }
    });
  }
  ngAfterViewInit() {
    this.loadGoogleTranslate();
  }
  loadCountryCodes() {
    this.originalCountries = getCountries().map((country) => ({
      code: `+${getCountryCallingCode(country)}`, // Includes '+'
      flag: `https://flagcdn.com/16x12/${country.toLowerCase()}.png`,
    }));
    this.countries = this.originalCountries;
  }

  checkUser() {
    let currentuser = localStorage.getItem('currentUser');
    this.accessKey = this.route.snapshot.queryParams['access_key'] || '';

    if (currentuser) {
      // Restore state immediately from localStorage
      this.authenticationService.getSavedUser();
      this.isLoggedIn = true;

      // Refresh token in background
      this.authenticationService.refreshToken().subscribe(
        (val) => {
          // Token refreshed successfully
          this.authenticationService.getSavedUser();
        },
        (err) => {
          console.error('Token refresh failed:', err);
          // Only log out if it's definitely a 401 Unauthorized
          if (err.status === 401 || err.statusText === 'Unauthorized') {
            localStorage.removeItem('currentUser');
            this.authenticationService.sendCurrentUserSubject({});
            this.authenticationService.sendLoginUser(false);
            this.isLoggedIn = false;
          }
        }
      );
      let currentUser2 = JSON.parse(currentuser);
      if (currentUser2 != null) {
        if (currentUser2.username != 'chemrobouser') {
          this.accessKey = btoa(currentUser2.userid || currentUser2.id);
        }
      }
    } else {
      if (this.accessKey != '' && currentuser == null) {
        this.authenticationService.auto_login2(this.accessKey).subscribe(
          (res) => {
            if (res == null) {
            } else {
              window.location.reload();
            }
          },
          (error) => {
            console.log(error);
          }
        );
      }
    }
  }
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const dropdown = document.querySelector(
      '.header_top_left_box1_item_icon1_dropdown'
    );
    const toggle = document.querySelector('.selected-option');
    // Check if the dropdown exists and if the click is outside the dropdown or toggle
    if (
      dropdown &&
      !dropdown.contains(target) &&
      toggle &&
      !toggle.contains(target)
    ) {
      this.dropdownOpen = false;
      // this.selectedMenu = '';
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (
      this.userSetting &&
      this.userSettingDialog &&
      !this.userSettingDialog.nativeElement.contains(event.target)
    ) {
      this.userSetting = false;
    }
  }

  loadGoogleTranslate() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
      function googleTranslateElementInit() {
        new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
      }
      googleTranslateElementInit();
    `;
    // document.head.appendChild(script);
  }
  onBrochureChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const selectedBrochure = target.value;
    if (selectedBrochure) {
      window.open(selectedBrochure, '_blank');
    }
  }
  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

  toggleUserSetting(event: MouseEvent): void {
    event.stopPropagation();
    this.userSetting = !this.userSetting;
  }
  getBrochureData() {
    this.datasearch.getBrochure().subscribe(
      (res) => {
        if (res && res.data) {
          this.brochures = res.data.map((brochure: any) => ({
            id: brochure._id,
            fileName: brochure.file_name || 'Unknown Brochure',
            brochureUrl: `https://www.chemrobotics.com/agropat/uploads/brochures/${brochure.brochure}`,
          }));
        }
      },
      (error) => {
        console.error('Error fetching brochures: ', error);
      }
    );
  }
  selectBrochure(brochure: any) {
    this.selectedBrochure = brochure;
    this.dropdownOpen = false;

    // Open the selected brochure in a new tab
    if (brochure.brochureUrl) {
      window.open(brochure.brochureUrl, '_blank');
    } else {
      console.error('Invalid brochure URL');
    }
  }
  getHeaderData() {
    this.datasearch.getHeader().subscribe(
      (res) => {
        if (res.success) {
          this.headerData = res.data;
          if (this.headerData && this.headerData.header_logo && this.headerData.header_logo.startsWith('layout-logos-')) {
            this.logoUrl = `${this.datasearch.ApiUrl}/uploads/layout-logos/`;
          } else {
            this.logoUrl = 'https://www.chemrobotics.com/agropat/uploads/thumbnail/';
          }
        } else {
          this.headerData = {};
        }
      },
      (error) => {
        this.headerData = {};
        console.error('Error fetching header data', error);
      }
    );
  }
  getList() {
    this.lists = [
      '<strong>Trial Access:</strong> ChemRobotics® offers trial access for users interested in evaluating our database. Please note that ChemRobotics® is a premium service requiring a paid subscription.',
      '<strong>Registration Policy:</strong> In accordance with our database policy, we request that users register using their official company domain email. Personal email addresses (e.g., Gmail, Yahoo, Rediff) are not accepted for the sign-up process.',
      '<strong>Accurate Sign-Up Information:</strong> To ensure an optimal experience, we ask that users provide accurate and complete details during the sign-up process. The ChemRobotics® support team will review the submitted information, and any incorrect, false, or incomplete data may result in the denial of trial access.',
      '<strong>Activation Process:</strong> Once the sign-up process is successfully completed, our support team will review the registration details. If approved, the user will receive an activation email directly from the ChemRobotics® support team.',
    ];
  }
  initialiseForm() {
    this.signInForm = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
    this.demorequestForm = this.fb.group({
      verticals: [''], // No validators for this, set dynamically
      date: ['', Validators.required],
      time: ['', Validators.required],
      fname: ['', Validators.required],
      lname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      country_code: ['+91', Validators.required],
      phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      job: ['', Validators.required],
      company: ['', Validators.required],
      country: ['', Validators.required],
      industry: ['', Validators.required],
      comment: [''],
      web: ['Agro'],
      source: [''],
      // Remove recaptcha from the form
    });
    this.signUpForm = this.fb.group({
      address: ['', Validators.required],
      // company_email_id: ['', [Validators.required, Validators.email]],
      company_name: ['', Validators.required],
      // country_code: ['+91', Validators.required],
      country_name: ['', Validators.required],
      gender: ['', Validators.required],
      department_name: ['', Validators.required],
      education: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      firstname: ['', Validators.required],
      industry: ['', Validators.required],
      institute_company: ['', Validators.required],
      lastname: ['', Validators.required],
      mobile_no: ['', [Validators.required]],
      notify_update: ['true', Validators.required],
      occupation: ['', Validators.required],
      password: ['', [Validators.required]],
      pincode: ['', Validators.required],
      state: ['', Validators.required],
      prefix: ['', Validators.required],
      scientific_profession: [[]],
      web: ['Agro'],
    });
  }
  onCaptchaSuccess(token: string | null) {
    this.recaptchaResponse = token;
    // this.startCaptchaResetTimer();
  }
  // Reset reCAPTCHA
  resetCaptcha() {
    this.recaptchaResponse = null;
    this.recaptchaRef.reset();
  }
  startCaptchaResetTimer() {
    setTimeout(() => {
      this.resetCaptcha();
    }, 50000);
  }

  LogoutClick() {
    this.authenticationService.logout();
    this.userSetting = false;
    this.accessKey = '';
    this.selectedMenu = '';
    this.isLoggedIn = false;
    const currentRoute = this.router.url;
    this.router.navigate(['/home']);
    if (currentRoute === '/profile' || currentRoute === '/edit_profile') {
      this.router.navigate(['/home']);
    }
  }

  getLabels() {
    this.datasearch.getUserprofession().subscribe(
      (res) => {
        this.labels = res.data.map((item: any) => ({
          id: item.id,
          profession: item.profession,
          checked: false,
        }));
        this.ids = res.data.map((item: any) => item.id);
      },
      (err) => { }
    );
  }

  submit_signin_form() {
    if (this.signInForm.invalid) {
      this.signInForm.markAllAsTouched();
      return;
    }

    const postdata = {
      username: this.signInForm.value.username,
      password: this.signInForm.value.password,
    };

    this.isLoggingIn = true;
    this.busyService.busy();
    this.authenticationService.user_login(postdata).subscribe(
      (res) => {
        this.isLoggedIn = true;
        this.isLoggingIn = false;
        this.busyService.idle();
        this.isSignedIn = true;

        // Reset form to signal browser that submission is finished
        this.signInForm.reset();
        this.signInForm.markAsPristine();
        this.signInForm.markAsUntouched();

        // Close the modal and allow background scrolling
        this.closeSignInModal();

        // Soft route refresh to trigger browser password alerts immediately
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([this.router.url]);
        });
      },
      (err) => {
        this.isLoggingIn = false;
        this.busyService.idle();
        this.errorMessage1 = err.error.message || 'Invalid username or password';
        this.signInForm.reset();
        this.signInForm.markAsUntouched();
      }
    );
  }
  updateCount() {
    this.selectedCountsignup = this.labels.filter(
      (profession) => profession.checked
    ).length;
  }

  toggleCheckbox(index: number) {
    this.labels[index].checked = !this.labels[index].checked;
    this.updateCount();
  }

  toggleSecondForm() {
    this.signUpForm.controls['scientific_profession'].setValue(
      this.labels.filter((val) => val.checked).map((val) => val.id)
    );
    // this.showSecondForm = true; // Change to true directly, manage visibility in template
    this.showSecondForm = !this.showSecondForm;
  }

  isNextButtonEnabled() {
    return this.selectedCountsignup > 0;
  }

  allSecondFormValid(): boolean {
    const controls = [
      'institute_company',
      'department_name',
      'industry',
      'company_name',
      'occupation',
      'country_name',
      'state',
      'address',
      'pincode',
    ];
    return controls.every((control) => this.signUpForm.get(control)?.valid);
  }

  toggleThirdForm() {
    this.isSubmitted = true;
    if (this.showSecondForm) {
      if (this.allSecondFormValid()) {
        this.showSecondForm = false;
        this.showThirdForm = true;
        this.isSubmitted = false; // Reset submitted state for the next step
      } else {
        this.signUpForm.markAllAsTouched(); // Show validation errors for second form
        this.errorMessage = 'Please fill in all required fields correctly.'; // Optional: Add a general error message
      }
    }
  }

  previousForm() {
    if (this.showThirdForm) {
      this.showThirdForm = false;
      this.showSecondForm = true;
    } else if (this.showSecondForm) {
      this.showSecondForm = false; // Add this line to go back to the first form
      // Optionally set a flag to show the first form if needed
    }
  }
  submit_signup_form() {
    this.isSubmitted = true;
    this.errorMessage = '';

    const termsChecked = (document.getElementById('terms-checkbox') as HTMLInputElement)?.checked;

    if (!termsChecked) {
      this.errorMessage = 'Please agree to the Terms of use and Privacy policy.';
      return;
    }

    if (!this.recaptchaResponse) {
      this.errorMessage = 'Please complete the reCAPTCHA.';
      return;
    }

    if (this.signUpForm.invalid) {
      this.signUpForm.markAllAsTouched();
      this.errorMessage = 'Please fill in all required fields correctly.';
      return;
    }

    // Show busy indicator
    this.isSigningUp = true;
    this.busyService.busy();

    let postData = this.signUpForm.value;

    this.datasearch.sendSignup(postData).subscribe(
      (response) => {
        this.isSigningUp = false;
        this.busyService.idle();

        if (response.status == 'error') {
          alert(response.message);
        } else {
          this.successMessage = 'Thank you for registering with ChemRobotics®';
          this.router.navigate(['/']);
          this.signUpForm.reset();
          this.isSubmitted = false;
          this.closeSignUpModal();
          this.authenticationService.sendCurrentUserSubject(response);
        }
      },
      (error) => {
        this.isSigningUp = false;
        this.busyService.idle();

        if (error.error && error.error.message) {
          this.errorMessage = error.error.message;
        } else {
          this.errorMessage = 'An unexpected error occurred. Please try again later.';
        }
        console.error('Signup error:', error);
      }
    );
  }

  handleSignupError(error: any) {
    // You can customize the error handling logic as per your requirements
    if (
      error.status === 409 ||
      error.message.includes('User with this email already exists!')
    ) {
      this.errorMessage = 'User with this email already exists!';
    } else if (error.status === 400) {
      this.errorMessage = 'Invalid input. Please check your data.';
    } else {
      this.errorMessage =
        'An unexpected error occurred. Please try again later.';
    }

    // Optionally, you could reset the form or perform other actions
    this.signUpForm.reset(); // Reset the form if needed
    this.signUpForm.markAsUntouched(); // Mark all fields as untouched to reset validation states
  }

  getErrorMessages() {
    let errorMessages = '';

    Object.keys(this.signUpForm.controls).forEach((key) => {
      const controlErrors = this.signUpForm.get(key)?.errors;
      if (controlErrors) {
        Object.keys(controlErrors).forEach((errorKey) => {
          errorMessages += `${key}: ${errorKey} error\n`; // Customize error messages per field
        });
      }
    });

    return (
      errorMessages ||
      'Please fill in all required fields correctly and complete reCAPTCHA.'
    );
  }

  closeSignUpModal() {
    const modalElement = document.getElementById('sign-up');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
        modalInstance.dispose();
        // Allow background scrolling
        document.body.classList.remove('modal-open'); // Remove Bootstrap modal-open class
        document.body.style.overflow = ''; // Reset overflow style to default
      }
    }

    // Manually remove any remaining backdrop elements
    const backdrops = document.getElementsByClassName('modal-backdrop');
    while (backdrops.length > 0) {
      document.body.removeChild(backdrops[0]);
    }
  }
  // Functions related to Demo Request Form
  toggleVerticalChecked(index: number) {
    this.verticals[index].checked = !this.verticals[index].checked;
    this.updateSelectedCount();
    this.updateVerticalsFormControl();
  }

  updateVerticalsFormControl() {
    const selectedVerticals = this.verticals
      .filter((v) => v.checked)
      .map((v) => v.vertical)
      .join(', ');
    this.demorequestForm.controls['verticals'].setValue(selectedVerticals);
  }

  submit_demo_form() {
    this.formSubmitted = true;

    if (this.demorequestForm.invalid || !this.recaptchaResponse) {
      this.demorequestForm.markAllAsTouched();
      return;
    }

    // Capture selected verticals
    const verticalArr = this.verticals
      .filter((v) => v.checked)
      .map((v) => v.vertical)
      .join();
    this.demorequestForm.controls['verticals'].setValue(verticalArr);

    // Capture checked sources
    const sourceArr = Array.from(
      document.querySelectorAll('input[name="source"]:checked')
    )
      .map((el: any) => el.value)
      .join();
    this.demorequestForm.controls['source'].setValue(sourceArr);

    // Append ':00' to the time value if not already appended
    if (!this.demorequestForm.value.time.includes(':00')) {
      this.demorequestForm.value.time += ':00';
    }

    // Prepare email data
    const emailPostData = {
      to: 'support@chemrobotics.com',
      cc: 'greenbookcorp@gmail.com',
      subject: 'Demo Request (Agro)',
      html: `
        <div style="background-color: #ffc702; height:30px; text-align: center;">
        ChemRobotics
        </div>
        <div style="background-color: #eee;">
            <p>New demo request received now!</p>
        </div>
        <div style="background-color: #eee;">
            <p>Name: <strong>${this.demorequestForm.value.fname} ${this.demorequestForm.value.lname}</strong></p>
        </div>
        <div style="background-color: #eee;">
            <p>Email: <strong>${this.demorequestForm.value.email}</strong></p>
        </div>
        <div style="background-color: #eee;">
            <p>Phone: <strong>${this.demorequestForm.value.phone}</strong></p>
        </div>
        <div style="background-color: #eee;">
            <p>Job: <strong>${this.demorequestForm.value.job}</strong></p>
        </div>
        <div style="background-color: #eee;">
            <p>Company: <strong>${this.demorequestForm.value.company}</strong></p>
        </div>
        <div style="background-color: #eee;">
            <p>Country: <strong>${this.demorequestForm.value.country}</strong></p>
        </div>
        <div style="background-color: #eee;">
            <p>Industry: <strong>${this.demorequestForm.value.industry}</strong></p>
        </div>
        <div style="background-color: #eee;">
            <p>Demo Date: <strong>${this.demorequestForm.value.date}</strong></p>
        </div>
        <div style="background-color: #eee;">
            <p>Demo Time: <strong>${this.demorequestForm.value.time}</strong></p>
        </div>
        <div style="background-color: #eee;">
            <p>Vertical/Platform: <strong>${this.demorequestForm.value.verticals}</strong></p>
        </div>
        <div style="background-color: #eee;">
            <p>Comment: <strong>${this.demorequestForm.value.comment}</strong></p>
        </div>
        <hr>
        <div style="background-color: #eee; text-align: center;">
            <p>Copyright 2023 <strong><a href="https://www.chemrobotics.com/">ChemRobotics®</a></strong></p>
        </div>
      `,
    };

    const postdata = {
      demoRequest: this.demorequestForm.value,
      emailPostData: emailPostData,
    };

    this.busyService.busy();
    this.datasearch.sendDemorequest(postdata).subscribe(
      (response) => {
        this.busyService.idle();
        this.messageService.add({
          severity: 'success',
          summary: 'Submited',
          detail:
            'Thank you for your demo request. The ChemRobotics® team will reach out to you shortly.',
          life: 4000,
        });
        // this.openmodelalert();
        setTimeout(() => {
          this.router.navigate(['/home']);
        }, 2000);
        this.demorequestForm.reset();
        this.formSubmitted = false;
        this.closeDemoRequestModal();
        // this.resetCaptcha();
      },
      (error) => {
        this.busyService.idle();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error on submitting Demo Request',
          life: 4000,
        });
        console.log('Error:', error);
      }
    );
  }
  closeAlert() {
    this.alertVisible = false;
  }

  // Utility Functions
  updateSelectedCount() {
    this.selectedCountdemo = this.verticals.filter(
      (vertical) => vertical.checked
    ).length;
  }

  isNextButtonEnabledDemo() {
    return this.selectedCountdemo > 0;
  }

  closeSignInModal() {
    const modalElement = document.getElementById('sign-in');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
        modalInstance.dispose();
        // Allow background scrolling
        document.body.classList.remove('modal-open'); // Remove Bootstrap modal-open class
        document.body.style.overflow = ''; // Reset overflow style to default
      }
    }

    // Manually remove any remaining backdrop elements
    const backdrops = document.getElementsByClassName('modal-backdrop');
    while (backdrops.length > 0) {
      document.body.removeChild(backdrops[0]);
    }
  }

  submitForgotPasswordForm() {
    if (this.forgotPasswordForm.valid && this.recaptchaResponse) {
      this.formSubmitted = true;
      const email = this.forgotPasswordForm.get('email')?.value;
      this.sentEmail = email;
      const formData = new FormData();
      formData.append('username', email);
      formData.append('web', 'Agro');
      this.busyService.busy();
      this.datasearch.sendForgotpswd(formData).subscribe(
        (response) => {
          this.busyService.idle();
          this.formSubmitted = false;
          this.forgotmodelclose();
          if (response.status === 'success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Check Email',
              detail: response.message,
              life: 10000,
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: response.message,
              life: 10000,
            });
          }
        },
        (error) => {
          this.busyService.idle();
          this.errorMessageforgot =
            'An error occurred while sending the request.';
        }
      );
    } else {
      this.errorMessageforgot = 'Please provide a valid email address.';
    }
  }
  forgotmodelclose() {
    const modalElement = document.getElementById('forgot-password');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
        modalInstance.dispose();
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
      }
    }

    // Manually remove any remaining backdrop elements
    const backdrops = document.getElementsByClassName('modal-backdrop');
    while (backdrops.length > 0) {
      document.body.removeChild(backdrops[0]);
    }
  }
  closeSigninModel() {
    const modalElement = document.getElementById('sign-in');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
        modalInstance.dispose();
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
      }
    }

    const backdrops = document.getElementsByClassName('modal-backdrop');
    while (backdrops.length > 0) {
      document.body.removeChild(backdrops[0]);
    }
  }
  showAlertModal() {
    const alertModalElement = document.getElementById('alertModelforgot');
    if (alertModalElement) {
      $('#alertModelforgot').modal('show');
      setTimeout(() => {
        $('#alertModelforgot').modal('hide');
      }, 2000);
    }
  }

  openmodelalert() {
    const alertModalEl = this.alertModal.nativeElement;
    const bsAlertModal = new bootstrap.Modal(alertModalEl);
    bsAlertModal.show();
    setTimeout(() => {
      bsAlertModal.hide();
    }, 5000);
  }

  closeDemoRequestModal() {
    const modalElement = document.getElementById('demo-form');
    if (modalElement) {
      const bootstrapModal = bootstrap.Modal.getInstance(modalElement);
      if (bootstrapModal) {
        bootstrapModal.hide();
      }

      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach((backdrop) => backdrop.remove());

      document.body.style.overflow = '';

      setTimeout(() => {
        window.location.reload();
      }, 800);
    }
  }

  enterHeader() {
    this.overProductsDropdown = true;
    this.showDropdown();
  }

  leaveHeader() {
    this.overProductsDropdown = false;
    setTimeout(() => {
      this.hideDropdown();
    }, 10);
  }

  enterProductBox() {
    this.overAgroProducts = true;
    this.showDropdown();
  }

  leaveProductBox() {
    this.overAgroProducts = false;
    setTimeout(() => {
      this.hideDropdown();
    }, 10);
  }

  showDropdown() {
    this.showProducts = true;
  }
  atLeastOneCheckboxRequired(formArray: FormArray) {
    const isChecked = formArray.controls.some((control) => control.value);
    return isChecked ? null : { atLeastOneCheckboxRequired: true };
  }
  hideDropdown() {
    if (!this.overProductsDropdown && !this.overAgroProducts) {
      this.showProducts = false;
    }
  }

  enterHeaderDesc() {
    this.overHeaderDesc = true;
  }

  leaveHeaderDesc() {
    this.overHeaderDesc = false;
  }

  enterDescBox() {
    this.overDescDropdown = true;
  }

  leaveDescBox() {
    this.overDescDropdown = false;
  }

  enterHeaderServices() {
    this.overHeaderservices = true;
  }

  leaveHeaderServices() {
    this.overHeaderservices = false;
  }

  enterServicesBox() {
    this.overServicesDropdown = true;
  }

  leaveServicesBox() {
    this.overServicesDropdown = false;
  }

  openMenu(value: boolean) {
    this.showMenu = value;
    this.selectedMenu = '';
    if (this.homePage) {
      if (this.showMenu) {
        this.transparent = false;
      } else {
        this.transparent = window.pageYOffset > 70 ? false : true;
      }
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.homePage && typeof window !== 'undefined') {
      if (this.showMenu) {
        this.transparent = false;
      } else {
        this.transparent = window?.pageYOffset > 70 ? false : true;
      }
    } else {
      this.transparent = false;
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control?.markAsTouched();
      }
    });
  }

  copyToClipboarddemo() {
    const fixedUrl = 'https://www.chemrobotics.com/demo_request';
    navigator.clipboard
      .writeText(fixedUrl)
      .then(() => {
        this.copyMessage = 'The URL has been copied to your clipboard.';
        const copyToast = document.getElementById('copyToast');
        if (copyToast) {
          copyToast.classList.remove('hide');
          copyToast.classList.add('show');

          // Hide the toast after a few seconds
          setTimeout(() => {
            copyToast.classList.remove('show');
            copyToast.classList.add('hide');
          }, 3000);
        }
      })
      .catch((err) => {
        console.error('Failed to copy the URL: ', err);
      });
  }

  copyToClipboardsignup() {
    const fixedUrl = 'https://www.chemrobotics.com/registration';
    navigator.clipboard
      .writeText(fixedUrl)
      .then(() => {
        this.copyMessage = 'The URL has been copied to your clipboard.';
        const copyToast1 = document.getElementById('copyToast1');
        if (copyToast1) {
          copyToast1.classList.remove('hide');
          copyToast1.classList.add('show');

          // Hide the toast after a few seconds
          setTimeout(() => {
            copyToast1.classList.remove('show');
            copyToast1.classList.add('hide');
          }, 3000);
        }
      })
      .catch((err) => {
        console.error('Failed to copy the URL: ', err);
      });
  }

  togglePassword() {
    if (this.password === 'password') {
      this.password = 'text';
      this.show = true;
    } else {
      this.password = 'password';
      this.show = false;
    }
  }
}
